import React from 'react';
import PropTypes from 'prop-types';
import TripBoardHitNewModal from '../TripBoardHit/TripBoardHitNewModal';
import {ButtonIcon} from '@homeaway/react-buttons';
import './AddToTripBoardNewModal.less';

function AddToTripBoardNewModal(props) {
    const {onTripBoardClicked, onCreateBoardClicked, tripBoards, translations} = props;

    const tripBoardHits = tripBoards.map((tripBoard, index) => {
        const {boardId, name, listings = []} = tripBoard;
        const thumbnails = listings
            .filter((listing) => listing && listing.images)
            .reduce((currentThumbnails, listing) => {
                return currentThumbnails.concat([listing.images[0].c6_uri]);
            }, []);

        const onClick = (event) => {
            onTripBoardClicked(event, boardId);
        };

        return (
            <TripBoardHitNewModal
                key={`trip-board-hit-${index}`}
                onClick={onClick}
                tripBoardTitle={name}
                thumbnails={thumbnails}
            />
        );
    });

    const createButtonText = translations['tripboards.modal.create.new.list'];

    const handleAddNewTripBoard = () => {
        onCreateBoardClicked();
    };

    return (
        <React.Fragment>
            <div className="add-to-tripboard__scrollable-tripboards">{tripBoardHits}</div>
            <div className="add-to-tripboard__create-button-container" onClick={handleAddNewTripBoard} role="button">
                <div className="add-to-tripboard__shadow">
                    <div className="add-to-tripboard__create-button">
                        <ButtonIcon className="add-to-tripboard__create-button-icon" circle label={createButtonText}>
                            <svg className="add-to-tripboard__create-svg-plus" viewBox="0 0 50 50">
                                <path d="M50 22H28V0h-6v22H0v6h22v22h6V28h22" />
                            </svg>
                        </ButtonIcon>
                        <span className="add-to-tripboard__create-label">{createButtonText}</span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

AddToTripBoardNewModal.propTypes = {
    onTripBoardClicked: PropTypes.func,
    tripBoards: PropTypes.arrayOf(PropTypes.object)
};

AddToTripBoardNewModal.defaultProps = {
    onTripBoardClicked: () => {},
    onCreateBoardClicked: () => {},
    tripBoards: []
};

export default AddToTripBoardNewModal;
